import { Component, OnInit } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { Policy } from 'src/app/core/models/policy.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { LicenseService } from 'src/app/core/services/license.service';
import { UserService } from 'src/app/core/services/user.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-policy-list',
  templateUrl: './policy-list.component.html',
  styleUrls: ['./policy-list.component.scss']
})
export class PolicyListComponent implements OnInit {

  policies$ = new Observable<Pagination<Policy>>;
  policiesCollection$!: Policy[];

  user: User = utils?.localStorageGetItem('user');

  constructor(
    private licenseService: LicenseService,
    private userService: UserService,
    public configSvc: ConfigService
  ) { }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  ngOnInit() {
    if (!this.configSvc.currentConfigValue.teams) {
      this.userService.getTeams({ perPage: -1 }).pipe(map(res => {
        this.configSvc.setConfigParamsValue('teams', res.data);
      })).subscribe();
    }
    this.searchPolicies();
  }

  searchPolicies(pagination?: PaginationRequest) {
    this.policies$ = this.licenseService.indexPolicies(pagination ?? {}).pipe(tap(result => this.policiesCollection$ = result.data));;
  }

  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        const propsToRemove = ['name', 'parentEntityId', 'contact', 'identityCode'];
        this.policiesCollection$.map((p: Policy) => {
          if (p.id === e.result.id) {
            utils.deepMerge(p, e.result);
            //p.packagePolicies = e.packagePolicies
          };
          /*
            {
              "id": 338,
              "packageTypeId": 4,
              "defaultTestDays": 0,
              "packageType": {
                "id": 4,
                "name": "Elite",
                "private": false,
                "testDays": 30
              }
            }
          */
        })
        break;
      default:
        break;
    }
  }


}
